import { isDefined } from '@sgme/fp';
import type { ReactElement } from 'react';

import { useFlexiForwardSelector } from '@/App/tiles/FlexiForward/FlexiForwardContext.ts';
import { FormattedPrice } from '@/components/ui/FormattedPrice.tsx';
import { getFlexiForwardQuote } from '@/store/flexi-forward/helpers/rfs.ts';
import { useAppSelector } from '@/store/hooks.ts';

export function PriceDisplay({ precision }: { precision: number }): ReactElement {
  const showColoredPrices = useAppSelector((state) => state.userPreferences.showColoredPrices);
  const forwardRate = useFlexiForwardSelector((flexiForward) => {
    const solvable = flexiForward.properties.solvable;
    const solvingTypeFromUi =
      flexiForward.properties?.solvingType === 'solveUpfront' ? 'PremiumPaymentAmount' : 'ForwardRate';

    const solvingType = isDefined(solvable) ? solvable : solvingTypeFromUi;
    const isSolvedForRate = solvingType === 'ForwardRate';

    const quote = getFlexiForwardQuote(flexiForward.properties.rfs);

    return isSolvedForRate && isDefined(quote?.forwardRate)
      ? Number.parseFloat(quote?.forwardRate)
      : isDefined(flexiForward.properties.rate)
        ? flexiForward.properties.rate
        : 0;
  });

  return (
    <div className="align-self-center">
      <div>
        <FormattedPrice
          value={forwardRate}
          precision={precision}
          exponentCount={1}
          size="md"
          plusPrefixHidden
          showColoredPrices={showColoredPrices}
        />
      </div>
    </div>
  );
}
